import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ErrorService {

    private error: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor() {
    }

    showError() {
        this.error.next(true);
    }

    clearError() {
        this.error.next(false);
    }

    getError(): Observable<boolean> {
        return this.error.asObservable();
    }

}
